require('Assets/scss/error.scss');
